import { useEffect } from 'react'
import { Control, Controller, UseFormSetValue } from 'react-hook-form'

import { useBreakpoint } from '../../../../hooks/useBreakpoint'
import {
  EmploymentJob,
  UnemploymentGapBeforeReason,
  UnemploymentGapBeforeReasonDetail,
} from '../../../../models/employment'
import { DropdownButton } from '../../../Dropdown/DropdownButton'
import { EmploymentHistoryForm } from '../EmploymentHistory'

interface EmploymentHistryItemUnemploymentGapDropdownProps {
  job: EmploymentJob
  control: Control<any, any>
  setValue: UseFormSetValue<EmploymentHistoryForm>
}

const options = [
  {
    label: UnemploymentGapBeforeReasonDetail.get(UnemploymentGapBeforeReason.PERSONAL),
    value: UnemploymentGapBeforeReason.PERSONAL,
  },
  {
    label: UnemploymentGapBeforeReasonDetail.get(UnemploymentGapBeforeReason.FAMILY_EMERGENCY),
    value: UnemploymentGapBeforeReason.FAMILY_EMERGENCY,
  },
  {
    label: UnemploymentGapBeforeReasonDetail.get(UnemploymentGapBeforeReason.VEHICLE_BREAKDOWN),
    value: UnemploymentGapBeforeReason.VEHICLE_BREAKDOWN,
  },
  {
    label: UnemploymentGapBeforeReasonDetail.get(UnemploymentGapBeforeReason.EMPLOYER_SHUT_DOWN),
    value: UnemploymentGapBeforeReason.EMPLOYER_SHUT_DOWN,
  },
  {
    label: UnemploymentGapBeforeReasonDetail.get(UnemploymentGapBeforeReason.FINANCIAL),
    value: UnemploymentGapBeforeReason.FINANCIAL,
  },
  {
    label: UnemploymentGapBeforeReasonDetail.get(UnemploymentGapBeforeReason.OTHER),
    value: UnemploymentGapBeforeReason.OTHER,
  },
]

export function EmploymentHistryItemUnemploymentGapDropdown({
  job,
  control,
  setValue,
}: EmploymentHistryItemUnemploymentGapDropdownProps) {
  const name = `unemployment.${job.id}}` as const
  const isMobile = useBreakpoint('xs')

  useEffect(() => {
    if (job.details.unemploymentGapBeforeReason) {
      setValue(name, job.details.unemploymentGapBeforeReason)
    }
    // Only initial value
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Controller
      render={({ field, fieldState }) => (
        <DropdownButton
          {...field}
          value={field.value}
          error={!!fieldState.error}
          options={options}
          label="Select reason"
          maxHeight={400}
          isFullWidth
          noMargin
          width="200px"
          align={isMobile ? 'right' : 'left'}
          buttonProps={{ variant: 'text' }}
        />
      )}
      name={name}
      control={control}
      rules={{ required: true }}
    />
  )
}
